// Try to restore theme from localStorage to prevent flicker
const storedUser = localStorage.getItem('user');
let initialPrimary = "#f87676";
let initialButton = "#30384d";

if (storedUser) {
  try {
    const user = JSON.parse(storedUser);
    if (user.theme_primary_color) initialPrimary = user.theme_primary_color;
    if (user.theme_button_color) initialButton = user.theme_button_color;
  } catch (e) {
    console.error('Failed to parse stored user theme', e);
  }
}

const state = {
  primaryColor: initialPrimary,
  buttonColor: initialButton,
  isDark: false,
};

const mutations = {
  setPrimaryColor(state, data) {
    state.primaryColor = data.primaryColor;
  },
  setButtonColor(state, data) {
    state.buttonColor = data.buttonColor;
  },
  setDarkMode(state) {
    // Force light mode
    state.isDark = false;
  },
  resetTheme(state) {
    state.primaryColor = "#f87676";
    state.buttonColor = "#f87676";
    state.isDark = false;
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};